import { Box } from '@mui/material';
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import React, { useLayoutEffect } from 'react';
import { getResponsiveBoxStyles, getScrollbarStyles } from 'utils/scrollbarStyles';

const DataTable = ({
  rows,
  columns,
  onRowClick,
  page,
  pageSize,
  rowCount,
  onPageChange,
  handleChangePageSize,
  isActive,
  loading,
}) => {
  const [paginationModel, setPaginationModel] = React.useState({
    page: page === 0 ? 0 : page - 1,
    pageSize: pageSize,
  });

  const handlePaginationModelChange = (newPaginationModel) => {
    if (paginationModel.pageSize !== newPaginationModel.pageSize) {
      newPaginationModel.page = 0;
      setPaginationModel(newPaginationModel);
      handleChangePageSize(newPaginationModel.pageSize);
    } else if (paginationModel.page !== newPaginationModel.page) {
      setPaginationModel(newPaginationModel);
      onPageChange(newPaginationModel.page + 1);
    }
  };

  const handleGridRowClick = (params) => {
    if (onRowClick) {
      onRowClick(params.id);
    }
  };

  const getRowClassName = (params) => {
    if (params.row.is_chargeback && params.row.is_fraud) {
      return 'chargeback-and-fraud-row';
    } else if (params.row.is_chargeback) {
      return 'chargeback-row';
    } else if (params.row.is_fraud) {
      return 'fraud-row';
    }
    return '';
  };

  const getRowClassNameActive = (params) => {
    if (!params.row.active) {
      return 'fraud-row';
    }
    return '';
  };

  const autosizeColumns = React.useMemo(
    () => columns?.filter((col) => col.autosize).map((col) => col.field) || [],
    [columns],
  );

  const apiRef = useGridApiRef();

  useLayoutEffect(() => {
    if (!loading && rows?.length > 0 && autosizeColumns.length > 0) {
      if (apiRef.current?.autosizeColumns) {
        apiRef.current.autosizeColumns({
          columns: autosizeColumns,
          includeOutliers: true,
          includeHeaders: true,
        });
      }
    }
  }, [loading, rows, autosizeColumns, apiRef]);

  return (
    <Box
      sx={{
        maxWidth: '100%',
        ...getScrollbarStyles(),
        ...getResponsiveBoxStyles(),
      }}
    >
      <DataGrid
        apiRef={apiRef}
        autosizeOnMount={autosizeColumns.length > 0}
        autosizeOptions={
          autosizeColumns.length > 0
            ? {
                columns: autosizeColumns,
                includeOutliers: true,
                includeHeaders: false,
              }
            : undefined
        }
        pagination
        paginationMode='server'
        paginationModel={paginationModel}
        onPaginationModelChange={handlePaginationModelChange}
        pageSizeOptions={[10, 25, 50, 100]}
        rows={rows}
        columns={columns}
        rowCount={rowCount}
        loading={loading}
        disableColumnMenu
        onRowClick={handleGridRowClick}
        getRowClassName={isActive === 'isActive' ? getRowClassNameActive : getRowClassName}
      />
    </Box>
  );
};

export default DataTable;
